var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { fetchSummary } from '../services/conflictResolutionService';
/** Loads the per-technician summary once, when the dialog opens. */
export const useConflictResolution = (inspectionId, enabled) => {
    const [summary, setSummary] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const load = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        setHasError(false);
        try {
            setSummary(yield fetchSummary(inspectionId));
        }
        catch (_a) {
            setHasError(true);
        }
        finally {
            setIsLoading(false);
        }
    }), [inspectionId]);
    useEffect(() => {
        if (!enabled)
            return;
        void load();
    }, [enabled, load]);
    return { summary, isLoading, hasError };
};
